import type { StoreHealthScore } from '@tailorcast/shared-types';

interface StoreHealthCardProps {
  data: StoreHealthScore;
}

function getHealthColor(score: number) {
  if (score >= 4) return 'text-green-600';
  if (score >= 3) return 'text-yellow-600';
  if (score >= 2) return 'text-orange-600';
  return 'text-red-600';
}

export function StoreHealthCard({ data }: StoreHealthCardProps) {
  return (
    <div className="card p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Store Health</h3>
      <div className="flex items-center gap-6">
        <div className="text-center">
          <div className={`text-4xl font-bold ${getHealthColor(data.storeHealthScore)}`}>
            {data.storeHealthScore.toFixed(1)}
          </div>
          <div className="text-xs text-gray-500 mt-1">Health Score</div>
        </div>
        <div className="flex-1 grid grid-cols-2 gap-3 text-sm">
          <div>
            <span className="text-gray-500">Opportunity:</span>{' '}
            <span className="font-medium">{data.opportunityScore.toFixed(1)}</span>
          </div>
          <div>
            <span className="text-gray-500">Products:</span>{' '}
            <span className="font-medium">{data.totalProducts}</span>
          </div>
          <div>
            <span className="text-gray-500">Below threshold:</span>{' '}
            <span className="font-medium">{data.productsBelowThreshold}</span>
          </div>
          <div>
            <span className="text-gray-500">Avg content:</span>{' '}
            <span className="font-medium">{data.avgContentScore.toFixed(1)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
